import React from 'react';
import { MockService } from '../../../../../types/rest/mockServiceTypes';
import { Filter } from '../../../../../store/mockServices/mockServiceTypes';
import BlazeTable from '../../../../../components/blazeTable/BlazeTable';
import {
  BlazeTableColDef,
  BlazeTableOptions,
  SelectAllType,
} from '../../../../../components/blazeTable/BlazeTable.types';
import Badges from '../../../../../components/statusIndicator/Badges';
import Status from '../../../../../components/statusIndicator/Status';
import { getLocationName, getMockServiceEndpoint } from '../../../../../utils/mockServiceUtils';
import _ from 'lodash';
import { filterListByKeyword } from '../../../../../utils/filterUtils';
import HeaderCell from '../../MockServices/Cells/HeaderCell';
import i18n from '../../../../../i18n';
import MockServiceDetail from '../../MockServices/MockServiceDetail/MockServiceDetail';

interface AssignModalMockServicesTableProps {
  mockServices: MockService[];
  filter: Filter;
  isLoading: boolean;
  onSelect: (selectedItems: any[], selectAll: SelectAllType) => void;
}

const AssignModalMockServicesTable = (props: AssignModalMockServicesTableProps) => {
  const cols: BlazeTableColDef[] = [
    {
      header: 'Name',
      accessor: 'name',
      isSortable: true,
      isExpandLink: true,
      width: 160,
    },
    {
      header: 'Service',
      accessor: 'serviceName',
      width: 120,
      headerComponent: (
        <HeaderCell
          title={i18n.t('mockServices:mockServicesTable.columnNames.service')}
          elevioHelpId={'Service_MockService_table'}
        />
      ),
      isSortable: true,
    },
    {
      header: 'Location',
      accessor: 'location',
      width: 120,
      cellComponent: (mockService: MockService) => {
        return getLocationName(mockService.harborId, mockService.shipId);
      },
      isSortable: true,
    },
    {
      header: 'Endpoint',
      accessor: 'endpoint',
      width: 160,
      cellComponent: (mockService: MockService) => {
        return getMockServiceEndpoint(mockService);
      },
      headerComponent: (
        <HeaderCell
          title={i18n.t('mockServices:mockServicesTable.columnNames.endpoint')}
          elevioHelpId={'creating-a-mock-service-help'}
        />
      ),
      isSortable: true,
    },
    {
      header: 'Badges',
      accessor: 'badges',
      width: 120,
      cellComponent: (mockService: MockService) => {
        return <Badges mockService={mockService} />;
      },
      isSortable: true,
    },
    {
      header: 'Hits',
      accessor: 'id',
      cellComponent: (mockService: MockService) => <span>{mockService.hits ? mockService.hits : '-'}</span>,
      width: 120,
      isSortable: true,
    },
    {
      header: 'Status',
      accessor: 'status',
      width: 120,
      cellComponent: (item: MockService) => <Status status={item.status as any} id={item.id} />,
      isSortable: true,
    },
  ];

  const getFilteredResults = () => {
    if (_.isNil(props.mockServices)) {
      return [];
    }

    return _.filter(
      filterListByKeyword(props.mockServices, props.filter.search, ['name', 'serviceName']),
      (item: MockService) => {
        if (props.filter.status || props.filter.serviceId) {
          return item.status === props.filter.status || item.serviceId === props.filter.serviceId;
        } else {
          return item;
        }
      },
    );
  };

  const tableOptions: BlazeTableOptions = {
    pageable: true,
    selectable: true,
    showRowExpander: true,
    columnDef: cols,
    noResultsText: 'No Virtual Services to display',
    selectAllDropdown: true,
    expandDetailComponent: (item: MockService) => (
      <div className={'p-4'}>
        <MockServiceDetail rowData={item} saveServiceHandler={_.noop} disabled={true} />
      </div>
    ),
  };

  return (
    <BlazeTable
      onSelectionChange={props.onSelect}
      isLoading={props.isLoading}
      options={tableOptions}
      data={getFilteredResults()}
    />
  );
};

export default AssignModalMockServicesTable;
